import React from 'react';
import { INK, OLIVE, SERIF, BODY } from './DagbladFrontPage';

const keyOf = (l) => `asst:${l.kind}:${l.time}:${l.text}`.slice(0, 120);
const dot = (t) => (t ? `kl. ${t.replace(':', '.')}` : '');

export function AssistantBox({ a, has, tick, onHide }) {
  if (!a) return null;
  return (
    <section className="mt-6 border-[3px] border-double p-4 sm:p-5" style={{ borderColor: INK, background: '#FBF7EE' }} data-testid="dagblad-assistant">
      <div className="flex items-start justify-between gap-2">
        <div>
          <p className="text-[10px] font-black uppercase tracking-[0.35em]" style={{ color: '#8C2F2F' }}>Elsas assistent</p>
          <h3 className="text-2xl font-black leading-tight" style={{ fontFamily: SERIF, color: INK }}>
            {a.when === 'idag' ? 'Det här gäller idag' : 'Det här gäller imorgon'}
          </h3>
          <p className="text-xs italic" style={{ fontFamily: BODY, color: OLIVE }}>Hämtat från din dagsplan, veckoplan, kalender och barnens schema</p>
        </div>
        {onHide && <button onClick={onHide} className="no-print text-[10px] font-bold opacity-40 hover:opacity-100" data-testid="dagblad-assistant-hide">✕ dölj</button>}
      </div>
      {a.lines.length ? (
        <ul className="mt-3 divide-y divide-dotted" style={{ borderColor: 'rgba(43,38,32,0.3)' }}>
          {a.lines.map((l, i) => {
            const k = keyOf(l);
            const done = has(k);
            return (
              <li key={k} className="flex items-start gap-3 py-2" data-testid={`dagblad-assistant-line-${i}`}>
                <button onClick={() => tick(k, !done)} aria-label={done ? 'Ångra' : 'Klart'}
                  className="mt-0.5 w-5 h-5 flex-shrink-0 border-2 flex items-center justify-center text-[11px] font-black"
                  style={{ borderColor: INK, background: done ? INK : 'transparent', color: '#F4EEE1' }} data-testid={`dagblad-assistant-check-${i}`}>{done ? '✓' : ''}</button>
                {l.time && <span className="w-16 flex-shrink-0 text-sm font-black whitespace-nowrap" style={{ color: OLIVE }}>{dot(l.time)}</span>}
                <span className={`text-[15px] leading-snug ${done ? 'line-through opacity-50' : ''}`} style={{ fontFamily: BODY }}>
                  <span className="mr-1">{l.icon}</span>{l.text}
                </span>
              </li>
            );
          })}
        </ul>
      ) : (
        <p className="mt-3 italic text-sm" style={{ fontFamily: BODY }}>Dagsplanen är tom. Fyll i den på Min Sida, så sammanfattar jag den här åt dig 💛</p>
      )}
    </section>
  );
}

export function NextDayBox({ a }) {
  if (!a?.next?.length) return null;
  return (
    <section className="mt-6 border-t-2 pt-3" style={{ borderColor: INK }} data-testid="dagblad-next-day">
      <p className="text-[11px] font-black uppercase tracking-[0.3em] mb-1" style={{ color: OLIVE }}>{a.next_label} ska du komma ihåg</p>
      {a.next.map((l, i) => (
        <p key={`${l.kind}-${i}`} className="text-[15px] py-0.5" style={{ fontFamily: BODY }} data-testid={`dagblad-next-line-${i}`}>
          {l.icon} {l.time ? <b>{dot(l.time)} </b> : null}{l.text}
        </p>
      ))}
    </section>
  );
}
